import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FileText, Video } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const API = process.env.REACT_APP_BACKEND_URL;
export const companyActaFileUrl = (id) => `${API}/api/company/acta-files/${id}`;

const ActaFilesButtons = ({ acta, fileUrl, compact = false }) => {
  const { token } = useParams();
  const [showVideo, setShowVideo] = useState(false);
  if (!acta.pdf_file_id && !acta.video_file_id) return null;

  const buildUrl = fileUrl || ((id) => `${API}/api/debtor/${token}/acta-files/${id}`);
  const btn = `inline-flex items-center gap-1 font-medium rounded-md border bg-white border-slate-200 text-slate-700 hover:bg-slate-100 transition-colors ${compact ? 'text-[11px] px-1.5 py-0.5' : 'text-xs px-2 py-1'}`;

  return (
    <div className={`flex flex-wrap gap-1.5 ${compact ? '' : 'mt-1.5'}`} data-testid={`acta-files-${acta.number}`}>
      {acta.pdf_file_id && (
        <a href={buildUrl(acta.pdf_file_id)} target="_blank" rel="noopener noreferrer" className={btn} data-testid={`acta-pdf-${acta.number}`} onClick={(e) => e.stopPropagation()}>
          <FileText className="w-3.5 h-3.5 text-rose-600" /> {compact ? 'PDF' : 'Ver Acta (PDF)'}
        </a>
      )}
      {acta.video_file_id && (
        <button type="button" onClick={(e) => { e.stopPropagation(); setShowVideo(true); }} className={btn} data-testid={`acta-video-${acta.number}`}>
          <Video className="w-3.5 h-3.5 text-indigo-600" /> {compact ? 'Video' : 'Ver Video'}
        </button>
      )}
      {acta.video_file_id && (
        <Dialog open={showVideo} onOpenChange={setShowVideo}>
          <DialogContent className="sm:max-w-2xl p-0 overflow-hidden bg-black border-0" data-testid={`acta-video-modal-${acta.number}`}>
            <DialogHeader className="p-3 pb-2 bg-white">
              <DialogTitle className="text-sm flex items-center gap-2"><Video className="w-4 h-4 text-indigo-600" />Video infracción - Acta {acta.number}</DialogTitle>
            </DialogHeader>
            <video src={buildUrl(acta.video_file_id)} controls autoPlay playsInline className="w-full max-h-[70vh] bg-black" data-testid={`acta-video-player-${acta.number}`} />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default ActaFilesButtons;
